import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.user.DOC}
  mutation CreateUser($info: UserInput!, $tenantContextId: ID) {
    createUser(info: $info, tenantContextId: $tenantContextId) {
      ...FragmentUser
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateUserMutation,
    models.User,
    'createUser'
  >('createUser', fragments.user.TRANSFORMER),
)

export const executor = graphql.createExecutor<
  graphql.schema.CreateUserMutation,
  models.User,
  graphql.schema.CreateUserMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
